import { Component, Input, OnInit } from '@angular/core';
import { MedigiComponentCopyService } from '../../medigi/medigi-component-copy.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  @Input() faqType = '';
  faqs;
  faqOpen = false;

  constructor(private medigiCopyService: MedigiComponentCopyService) {}

  ngOnInit() {
    this.getFaqs();
  }

  getFaqs() {
    if (this.faqType === 'pharmacy') {
      this.faqs = this.medigiCopyService.faq.pharmacy;
    } else if (this.faqType === 'manufacturer') {
      this.faqs = this.medigiCopyService.faq.manufacturer;
    }
  }

  openOrClose(index) {
    if (this.faqs[index]?.faqOpen === true) {
      this.faqs[index].faqOpen = false;
    } else {
      this.faqs[index].faqOpen = true;
    }
  }
}
